export const stepOption = [
    {
        value: "1a", title: "Выявление новых случаев С33-С34", type: "input", level: 1, col: 1,
        data: [52923.00,   52446.00,   52281.00,   53697.00,   55157.00,   55220.00,   56545.00,   55717.00,   53343.00,   47021.00],
        dataRegion: {
            '1100': {data: [52923.00,   52446.00,   52281.00,   53697.00,   55157.00,   55220.00,   56545.00,   55717.00,   53343.00,   47021.00], dataPredictor: 359,},
            '1101': {data: [1389.00,1308.00,1349.00,1263.00,1387.00,1343.00,1361.00,1314.00,1308.00,1072.00,1231.00], dataPredictor: -16,},
            '1145': {data: [2593.00, 2640.00, 2475.00, 2799.00, 2907.00, 2849.00, 3023.00, 2820.00, 2761.00, 2221.00, 2087.00], dataPredictor: -29,},

        },
        dataPredictor: 359,
        typex: "stage"
        , cr: `${process.env.PUBLIC_URL}/images/pdf/cr/KR30.pdf`
    },
    {value: "1", title: "Выявление новых случаев С34", typex: "_", col: 2, level: 1},
    {value: "mk1", title: "НМРЛ", typex: "_", col: 0.5, level: 2},
    {value: "mk2", title: "МРЛ", typex: "_", col: 2.5, level: 2},
    {value: "s1", title: "Стадия I НМРЛ", typex: "_", col: 0.5, level: 4,},
    {value: "s2", title: "Стадия II НМРЛ", typex: "_", col: 1.5, level: 4,},
    {value: "s3", title: "Стадия III НМРЛ", typex: "_", col: 2.5, level: 4,},
    {value: "s4", title: "Стадия IV НМРЛ", typex: "-", col: 3.5, level: 4,},
    /*
    {value: "sn1", title: "Стадия I МРЛ", typex: "_", col: 0.5, level: 3,},
    {value: "sn2", title: "Стадия II МРЛ", typex: "_", col: 1.5, level: 3,},
    {value: "sn3", title: "Стадия III МРЛ", typex: "_", col: 2.5, level: 3,},
    {value: "sn4", title: "Стадия IV МРЛ", typex: "_", col: 3.5, level: 3,},

     */
    {value: "sn2", title: "Распространённый МРЛ", typex: "_", col: 2.5, level: 3,},
    {value: "sn4", title: "Локализованный МРЛ", typex: "_", col: 3.5, level: 3,},

     {value: "pk1", title: "Плосколеточный", col: 2.75, level: 6},
     {value: "pk2", title: "Не плоскоклеточный", col: 3.5, level: 6},


    {
        value: "nooper", title: "Неоперабельные III/IV", col: 3.0, level: 5
    },

     {value: "pk1e", title: "ECOG 0-1", col: 2.75, level: 9},
     {value: "pk1em0", title: "ECOG 0-1", col: 3.75, level: 9},
    // {value: "pk1enm", title: "ECOG 0-1", col: 3.75, level: 9},
    {value: "pk2t1", title: "Протестированы", col: 4, level: 7},
     {value: "pk2t2", title: "Не протестированы", col: 3, level: 7},

     {value: "pk2t1m0", title: "Нет мутаций", col: 3, level: 8},
     {value: "pk2t1m1", title: "ALK+", col: 1.5, level: 8},
     {value: "pk2t1m2", title: "EGFR+", col: 4, level: 8},


     {value: "pk2t1m2s1", title: "ECOG 0-1", col: 4.5, level: 9},
     {value: "pk2t1m2s2", title: "Получают ИТК и прогрессирование", col: 4.5, level: 10},
     {value: "pk2t1m2s3", title: "Т790М отриц/неизв", col: 4.5, level: 11},
    //{value: "pk2t1m2s1", title: "ECOG 0-1", col: 4, level: 9},


    {value: "pk1es1", title: "Не получают ИТ", col: 2.75, level: 10},
    {value: "pk1es2", title: "Доживают до ИТ", col: 2.75, level: 11},

    {value: "pk1at", title: "Агрессиовное течение", col: 3.5, level: 10},

    {value: "pk1m3", title: "Тестирование PD-L1", col: 1.75, level: 10},
    {value: "pk1m4", title: "PD-L1 высокий", col: 1.75, level: 11},

    /*
    {value: "tp", title: "Протестировано", col: 2.75, level: 6},
    {value: "tn", title: "Не протестировано", col: 3.5, level: 6},

    {value: "m1", title: "EGFR+", col: 2.5, level: 7},
    {value: "m2", title: "ALK+", col: 2.5, level: 8},
    //{value: "m3", title: "ROS1, BRAF", col: 2.5, level: 7},
    // {value: "m4", title: "ERBB2", col: 3.5, level: 7},
    {value: "m5x", title: "Таргетная терапия, прогрессирование, Т790М - отриц/неизв", col: 1.5, level: 9},
    {value: "m5", title: "Высокая экспрессия PD-L1", col: 1.25, level: 8},
    {value: "m6", title: "Нет мутаций", col: 3.5, level: 8},

    {value: "trp1", title: "Платина +", col: 3.5, level: 9},
    {value: "trp2", title: "Платина -", col: 2.5, level: 9},

    {value: "prg", title: "Прогрессирование", col: 3, level: 10},
*/
    {
        value: "h1", title: "Алектиниб", typex: "treat", col: 1.5, level: 9,
        // getCont: {c1: 0.6}
    },
    {
        value: "h2", title: "Атезолизумаб + бевацизумаб + паклитаксел + карбоплатин", typex: "treat", col: 4, level: 12,
        // getCont: {c1: 0.6}
    },
    {
        value: "h3", title: "Атезолизумаб при прогрессировании", typex: "treat", col: 2.75, level: 12,
        // getCont: {c1: 0.6}
    },
    {
        value: "oper", title: "Прооперированы II", col: 0.5, level: 5
    },
    {
        value: "operv1", title: "Прооперированы IIIa", col: 1.25, level: 5
    },
    {
        value: "operv2", title: "Прооперированы IIIb", col: 2.0, level: 5
    },




    {
        value: "oper2", title: "Получают адъювантную терапию после R0 резекции", col: 0.5, level: 6
    },
    {
        value: "oper2v1", title: " Получают адъювантную терапию после R0 резекции", col: 1.25, level: 6
    },
    {
        value: "oper2v2", title: " Получают адъювантную терапию  после R0 резекции ", col: 2.0, level: 6
    },
    {value: "oper3", title: "PD-L1 >= 50%", col: 0.5, level: 9},
 //   {value: "h4", title: "Атезолизумаб (адьювант)", col: 0.5, level: 12},
    {value: "h4", title: "Атезолизумаб ", col: 0.5, level: 12},
    {value: "h5", title: "Атезолизумаб + карбоплатин + этопозид (МРЛ)", col: 4.5, level: 4},
    /*{
        value: "h6", title: "??? - новый портрет", typex: "treat", col: 1.5, level: 12,
        // getCont: {c1: 0.6}
    },

    /*    {value: "t1", title: "Целевая группа (новые)", col: 2, level: 4},
        {value: "mq", title: "ECOG (выбор терапии)", col: 2, level: 5},

        {value: "m1", title: "Цисплатин +", col: 1, level: 6},
        {value: "m2", title: "Цисплатин -", col: 3, level: 6},

        {value: "p2", title: "Прогрессирование (Цисплатин)", col: 1, level: 7},
        {value: "m3", title: "PD-L1 +", col: 2, level: 7},
        {value: "m4", title: "PD-L1 -", col: 3, level: 7},

        {value: "p3", title: "Прогрессирование (PD-L1-)", col: 3, level: 8},

        {
            value: "h1", title: "Пембра/Атеза (прогрессирование цисплатин)", typex: "treat", col: 1, level: 9,
            // getCont: {c1: 0.6}
        },
        {
            value: "h2", title: "Пембра/Атеза (PD-L1+)", typex: "treat", col: 2, level: 9,
            // getCont: {c1: 0.8}
        },
        {
            value: "h3", title: "Пембра/Атеза (PD-L1- прогрессирование)", typex: "treat", col: 3, level: 9,
            // getCont: {c1: 0.65}
        },
    */
]

const toPercent = (val) => Math.floor(val * 100)/100

export const stepConnection = [
    {source: "1a", target: "1", label: "", sender: {value: toPercent(0.93), ttl: "1"}},

    {source: "1", target: "mk2", label: "", sender: {value: toPercent(0.15), ttl: "1"}},
    {source: "1", target: "mk1", label: "", sender: {value: toPercent(0.85), ttl: "1"}},

    {source: "mk1", target: "s1", label: "", sender: {value: toPercent(0.14), ttl: "1"}},
    {source: "mk1", target: "s2", label: "", sender: {value: toPercent(0.14), ttl: "1"}},
    {source: "mk1", target: "s3", label: "", sender: {value: toPercent(0.28), ttl: "1"}},
    {source: "mk1", target: "s4", label: "", sender: {value: toPercent(0.43), ttl: "1"}},

    {source: "mk2", target: "sn1", label: "", sender: {value: toPercent(0.14), ttl: "1"}},
    {source: "mk2", target: "sn2", label: "", sender: {value: toPercent(0.70), ttl: "1"}},
    {source: "mk2", target: "sn3", label: "", sender: {value: toPercent(0.28), ttl: "1"}},
    {source: "mk2", target: "sn4", label: "", sender: {value: toPercent(0.30), ttl: "1"}},

    {source: "s3", target: "nooper", label: "", sender: {value: toPercent(0.55), ttl: "1"}},
    {source: "s4", target: "nooper", label: "", sender: {value: toPercent(1.0), ttl: "1"}},

    {source: "nooper", target: "pk1", label: "", sender: {value: toPercent(0.55), ttl: "1"}},
    {source: "nooper", target: "pk2", label: "", sender: {value: toPercent(0.45), ttl: "1"}},
    // {source: "s4", target: "pk1", label: "", sender: {value: toPercent(0.55), ttl: "1"}},
    // {source: "s4", target: "pk2", label: "", sender: {value: toPercent(0.45), ttl: "1"}},

    // {source: "pk1", target: "m5", label: "", sender: {value: toPercent(0.09), ttl: "1"}},
    // {source: "pk1", target: "tn", label: "", sender: {value: toPercent(0.52), ttl: "1"}},
    // {source: "pk2", target: "tp", label: "", sender: {value: toPercent(0.90), ttl: "1"}},
    // {source: "pk2", target: "tn", label: "", sender: {value: toPercent(0.59), ttl: "1"}},
    {source: "pk1", target: "pk1e", label: "", sender: {value: toPercent(0.69), ttl: "1"}},
    {source: "pk2", target: "pk2t1", label: "", sender: {value: toPercent(0.80), ttl: "1"}},
    {source: "pk2", target: "pk2t2", label: "", sender: {value: toPercent(0.20), ttl: "1"}},
    {source: "pk2t2", target: "pk1e", label: "", sender: {value: toPercent(0.69), ttl: "1"}},

    {source: "pk2t1", target: "pk2t1m0", label: "", sender: {value: toPercent(0.78), ttl: "1"}},
    {source: "pk2t1m0", target: "pk1em0", label: "", sender: {value: toPercent(0.69), ttl: "1"}},


    {source: "pk1em0", target: "pk1es1", label: "", sender: {value: toPercent(0.65), ttl: "1"}},
    {source: "pk1e", target: "pk1es1", label: "", sender: {value: toPercent(0.65), ttl: "1"}},
    {source: "pk1es1", target: "pk1es2", label: "", sender: {value: toPercent(0.61), ttl: "1"}},
    {source: "pk1es2", target: "h3", label: "", sender: {value: toPercent(1.0), ttl: "1"}},


    {source: "pk2t1", target: "pk2t1m1", label: "", sender: {value: toPercent(0.05), ttl: "1"}},
    {source: "pk2t1m1", target: "h1", label: "", sender: {value: toPercent(1.00), ttl: "1"}},

    {source: "pk2t1", target: "pk2t1m2", label: "", sender: {value: toPercent(0.17), ttl: "1"}},
    {source: "pk2t1m2", target: "pk2t1m2s1", label: "", sender: {value: toPercent(0.69), ttl: "1"}},
    {source: "pk2t1m2s1", target: "pk2t1m2s2", label: "", sender: {value: toPercent(0.50), ttl: "1"}},
    {source: "pk2t1m2s2", target: "pk2t1m2s3", label: "", sender: {value: toPercent(0.50), ttl: "1"}},
    {source: "pk2t1m2s3", target: "h2", label: "", sender: {value: toPercent(1), ttl: "1"}},

    {source: "pk1em0", target: "pk1at", label: "", sender: {value: toPercent(0.3), ttl: "1"}},
    {source: "pk1at", target: "h2", label: "", sender: {value: toPercent(1), ttl: "1"}},

    {source: "pk1e", target: "pk1m3", label: "", sender: {value: toPercent(0.9), ttl: "1"}},
    {source: "pk1em0", target: "pk1m3", label: "", sender: {value: toPercent(0.9), ttl: "1"}},
    {source: "pk1m3", target: "pk1m4", label: "", sender: {value: toPercent(0.21), ttl: "1"}},

    {source: "pk1m4", target: "h4", label: "", sender: {value: toPercent(1.0), ttl: "1"}},



    //{source: "pk1e", target: "pk1es1", label: "", sender: {value: toPercent(0.65), ttl: "1"}},
/*
    {source: "tn", target: "m6", label: "", sender: {value: toPercent(1), ttl: "1"}},
    {source: "tp", target: "m1", label: "", sender: {value: toPercent(0.17), ttl: "1"}},
    {source: "tp", target: "m2", label: "", sender: {value: toPercent(0.05), ttl: "1"}},
    {source: "tp", target: "m3", label: "", sender: {value: toPercent(0.015 + 0.03), ttl: "1"}}, // ROS1 BRAF
    {source: "tp", target: "m4", label: "", sender: {value: toPercent(0.021), ttl: "1"}},
    {source: "tp", target: "m5", label: "", sender: {value: toPercent(0.20), ttl: "1"}},
    {source: "tp", target: "m6", label: "", sender: {value: toPercent( 0.78), ttl: "1"}},

    {source: "m2", target: "h1", label: "", sender: {value: toPercent(1), ttl: "1"}},
    {source: "m5", target: "h6", label: "", sender: {value: toPercent(1)}},
    {source: "m6", target: "trp1", label: "", sender: {value: toPercent(0.55), ttl: "1"}},
    {source: "m6", target: "trp2", label: "", sender: {value: toPercent(0.45), ttl: "1"}},
    {source: "trp2", target: "prg", label: "", sender: {value: toPercent(1), ttl: "1"}},
    {source: "trp1", target: "prg", label: "", sender: {value: toPercent(0.4), ttl: "1"}},
    {source: "prg", target: "h3", label: "", sender: {value: toPercent(0.5), ttl: "1"}},
    {source: "m1", target: "m5x", label: "", sender: {value: toPercent(1), ttl: "1"}},
    {source: "m5x", target: "h2", label: "", sender: {value: toPercent(0.25), ttl: "1"}},

    */
    {source: "s2", target: "oper", label: "", sender: {value: toPercent(0.8), ttl: "1"}},
    {source: "s3", target: "operv1", label: "", sender: {value: toPercent(0.23), ttl: "1"}},
    {source: "s3", target: "operv2", label: "", sender: {value: toPercent(0.06), ttl: "1"}},



    {source: "oper", target: "oper2", label: "", sender: {value: toPercent(0.79)/*toPercent(0.88)*/, ttl: "1"}},
    {source: "operv1", target: "oper2v1", label: "", sender: {value:  toPercent(0.79)/*toPercent(0.8 * 0.95)*/, ttl: "1"}},
    {source: "operv2", target: "oper2v2", label: "", sender: {value:  toPercent(0.79)/*toPercent(0.71 * 1)*/, ttl: "1"}},
    {source: "oper2", target: "oper3", label: "", sender: {value: toPercent(0.21), ttl: "1"}},
    {source: "oper2v1", target: "oper3", label: "", sender: {value: toPercent(0.21), ttl: "1"}},
    {source: "oper2v2", target: "oper3", label: "", sender: {value: toPercent(0.21), ttl: "1"}},
    {source: "oper3", target: "h4", label: "", sender: {value: toPercent(1), ttl: "1"}},

    {source: "sn2", target: "h5", label: "", sender: {value: toPercent(1.0), ttl: "1"}},
    /*
    {source: "s2", target: "p1", label: "25%", sender: {value: "0.25", ttl: "1"}, mutator: {name: "M1", task: ["sender", "value"]}},
    {source: "s3", target: "p1", label: "30%", sender: {value: "0.30", ttl: "1"}, mutator: {name: "M2", task: ["sender", "value"]}},

    {source: "p1", target: "t1", label: "100%", sender: {value: "0.25", ttl: "1"}},
    {source: "s4", target: "t1", label: "80%", sender: {value: "0.30", ttl: "0"}},

    {source: "t1", target: "mq", label: "", sender: {value: "0.30", ttl: "0"}},

    {source: "mq", target: "m1", label: "68%", sender: {value: "0.68", ttl: "0"}},
    {source: "mq", target: "m2", label: "32%", sender: {value: "0.32", ttl: "0"}},

    {source: "m1", target: "p2", sender: {value: "0.43", ttl: "0"}},

    {source: "m2", target: "m3", label: "43%", sender: {value: "0.68", ttl: "0"}},
    {source: "m2", target: "m4", label: "57%", sender: {value: "0.32", ttl: "0"}},

    {source: "p2", target: "h1", sender: {value: "0.32", ttl: "0"}},
    {source: "m3", target: "h2", sender: {value: "1", ttl: "0"}},
    {source: "m4", target: "p3", sender: {value: "0.32", ttl: "0"}},
    {source: "p3", target: "h3", sender: {value: "1", ttl: "0"}}*/
]
export const modeling = [
    {
        value: "h1x", source: "h1", title: "Алектиниб", selector: 'H1', kmv:
            {
                A: [0.6, 0.4],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h2x", source: "h2", title: "Атезо (PD-L1 +)", selector: 'H2', kmv:
            {
                A: [0.65, 0.6],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h3x", source: "h3", title: "Атезо прогрессирование", selector: 'H3', kmv:
            {
                A: [0.7, 0.6],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h4x", source: "h4", title: "Атезо адьюванте", selector: 'H4', kmv:
            {
                A: [0.9, 0.85],
                B: [0.85, 0.8]
            },
    },
    {
        value: "h5x", source: "h5", title: "Атезо МРЛ", selector: 'H5', kmv:
            {
                A: [0.91, 0.83],
                B: [0.86, 0.82]
            },
    },
]
export const data = [
    {
        name: '2014',
        s1: 4000,
        s2: 2400,
        s3: 2400,
        s4: 1500,
    },
    {
        name: '2016',
        s1: 3000,
        s2: 1398,
        s3: 2210,
        s4: 5280,
    },
    {
        name: '2016',
        s1: 2000,
        s2: 9800,
        s3: 2290,
        s4: 2016,
    },
    {
        name: '2017',
        s1: 2780,
        s2: 3908,
        s3: 2000,
        s4: 1500,
    },
    {
        name: '2018',
        s1: 1890,
        s2: 4800,
        s3: 2181,
        s4: 3181,
    },
    {
        name: '2019',
        s1: 2390,
        s2: 3800,
        s3: 2500,
        s4: 2000,
    },
    {
        name: '2020',
        s1: 3490,
        s2: 4300,
        s3: 2100,
        s4: 1281,
    },
];

export const mainTrends = {
    stageI_II: {
        data: [64.57,  66.86,  69.11,  69.63,  71.25,  72.79,  74.16,  74.97,  76.25,  78.03,  77.32],
        ltr: 0.49
    },
    live5y: {
        data: [38.61,  38.73,  39.32,  40.08,  41.22,  41.99,  42.22,  43.45,  44.95, 44.95, 45.12],
        ltr: 0.79
    },
    live1y: {
        data: [ 53.17,  52.43,  51.81,  51.36,  50.48,  50.60,  49.64,  49.01,  48.39,  47.93],
        ltr: -0.57
    },
    dnl: {
        data: [49,        50,     51,     52,    53,      54,     55, 56,      57,   58,    59],
        ltr: 1
    },
    live5yttl: {
        data: [51.34,	51.07,	51.67,	52.43,	52.92,	53.34,	53.94,	54.45,	55.33,	56.57],
        ltr: 0.58
    },
    live1yttl: {
        data: [27.38, 26.09, 25.32, 24.77, 23.58, 23.25, 22.51, 22.25, 21.68, 20.60],
        ltr: -0.69
    }
}

const Model = {
    stepOption, stepConnection, mainTrends, data, modeling,
    defaultStrategy: {
        H1A: '5', H2A: '5', H3A: '5', H4A: '5', H5A: '5',
        H1B: '0', H2B: '0', H3B: '0', H4B: '0', H5B: '0',
        AZA: '5',
        AZB: '0',
        H1CV: '272', H2CV: '2991', H3CV: '6404', H4CV: '769', H5CV: '3258',
        M1: '90',
        M2: '30'
    },
    name: "Рак лёгкого",
    options: {
        showTrends: true,
        mainView: {
            title: "Выявление по стадиям, НМРЛ",
            lines: [
                {key: "s1", title: "I стадия"},
                {key: "s2", title: "II стадия"},
                {key: "s3", title: "III стадия"},
                {key: "s4", title: "IV стадия"},
            ]
        }
    },
    vars: {
        strategy: [

            {title: "Доля направленных на Атезолизумаб PD-L1+, %", prefix: "H2"},
            {title: "Доля направленных на Атезолизумаб прогрессирование, %", prefix: "H3"},
            {title: "Доля направленных на Атезолизумаб адьювант, %", prefix: "H4"},
            {title: "Доля направленных на Атезолизумаб МРЛ, %", prefix: "H5"},
            {title: "Доля направленных на Алектиниб, %", prefix: "H1"},
        ],
        mutation: [
            {title: "Диагностика, %", prefix: "M1"},
            // {title: "Прогрессирование после III стадии, %", prefix: "M2"},
        ]
    },
    buildTotalPrep: true,
    generator: '1a'
}

export default Model

/*export const stepOption = [
    {
        value: "1", title: "Выявление новых случаев", type: "input", level: 1,
        data: [13395, 13866, 13933, 14446, 15438, 15924, 16633, 16819, 16601, 14622],
        dataPredictor: 1255
    },
    {
        value: "s1", title: "Стадия I", typex: "stage", col: 0.5, level: 2,
        data: [4498, 5186, 5475, 5966, 6716, 7433, 8199, 8606, 9058, 7910], dataPredictor: 385
    },
    {
        value: "s2", title: "Стадия II", typex: "stage", col: 1.5, level: 2,
        data: [4458, 4397, 4227, 4327, 4522, 4376, 4271, 4218, 3895, 3395], dataPredictor: 15,
    },
    {
        value: "s3", title: "Стадия III", typex: "stage", col: 2.5, level: 2,
        data: [2593, 2423, 2371, 2338, 2324, 2138, 2142, 2111, 1820, 1756], dataPredictor: 18
    },
    {
        value: "s4", title: "Стадия VI", typex: "stage", col: 3.5, level: 2,
        fixed: "toTable",
        data: [1284, 1393, 1439, 1409, 1482, 1537, 1641, 1593, 1595, 1371], dataPredictor: 70
    },

    {value: "p1", title: "Прогрессирование (вне модели)", col: 2, level: 3},

    {value: "t1", title: "Целевая группа (новые)", col: 2, level: 4},
    {value: "mq", title: "ECOG (выбор терапии)", col: 2, level: 5},

    {value: "m1", title: "Цисплатин +", col: 1, level: 6},
    {value: "m2", title: "Цисплатин -", col: 3, level: 6},

    {value: "p2", title: "Прогрессирование (Цисплатин)", col: 1, level: 7},
    {value: "m3", title: "PD-L1 +", col: 2, level: 7},
    {value: "m4", title: "PD-L1 -", col: 3, level: 7},

    {value: "p3", title: "Прогрессирование (PD-L1-)", col: 3, level: 8},

    {
        value: "h1", title: "Пембра/Атеза (прогрессирование цисплатин)", typex: "treat", col: 1, level: 9,
        // getCont: {c1: 0.6}
    },
    {
        value: "h2", title: "Пембра/Атеза (PD-L1+)", typex: "treat", col: 2, level: 9,
        // getCont: {c1: 0.8}
    },
    {
        value: "h3", title: "Пембра/Атеза (PD-L1- прогрессирование)", typex: "treat", col: 3, level: 9,
        // getCont: {c1: 0.65}
    },

]
export const stepConnection = [
    {source: "1", target: "s1", label: "", generator: "S1"},
    {source: "1", target: "s2", label: "", generator: "S2"},
    {source: "1", target: "s3", label: "", generator: "S3"},
    {source: "1", target: "s4", label: "", generator: "S4"},

    {source: "s2", target: "p1", label: "25%", sender: {value: "0.25", ttl: "1"}, mutator: {name: "M1", task: ["sender", "value"]}},
    {source: "s3", target: "p1", label: "30%", sender: {value: "0.30", ttl: "1"}, mutator: {name: "M2", task: ["sender", "value"]}},

    {source: "p1", target: "t1", label: "100%", sender: {value: "0.25", ttl: "1"}},
    {source: "s4", target: "t1", label: "80%", sender: {value: "0.30", ttl: "0"}},

    {source: "t1", target: "mq", label: "", sender: {value: "0.30", ttl: "0"}},

    {source: "mq", target: "m1", label: "68%", sender: {value: "0.68", ttl: "0"}},
    {source: "mq", target: "m2", label: "32%", sender: {value: "0.32", ttl: "0"}},

    {source: "m1", target: "p2", sender: {value: "0.43", ttl: "0"}},

    {source: "m2", target: "m3", label: "43%", sender: {value: "0.68", ttl: "0"}},
    {source: "m2", target: "m4", label: "57%", sender: {value: "0.32", ttl: "0"}},

    {source: "p2", target: "h1", sender: {value: "0.32", ttl: "0"}},
    {source: "m3", target: "h2", sender: {value: "1", ttl: "0"}},
    {source: "m4", target: "p3", sender: {value: "0.32", ttl: "0"}},
    {source: "p3", target: "h3", sender: {value: "1", ttl: "0"}}
]
export const modeling = [
    {
        value: "h1x", source: "h1", title: "Атеза (прогрессирование цисплатин)", selector: 'H1', kmv:
            {
                A: [0.6, 0.4],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h2x", source: "h2", title: "Атеза (PD-L1 +)", selector: 'H2', kmv:
            {
                A: [0.6, 0.4],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h3x", source: "h3", title: "Атеза (DP-L1 -)", selector: 'H3', kmv:
            {
                A: [0.6, 0.4],
                B: [0.8, 0.7]
            },
    },
]
export const data = [
    {
        name: '2014',
        s1: 4000,
        s2: 2400,
        s3: 2400,
        s4: 1500,
    },
    {
        name: '2016',
        s1: 3000,
        s2: 1398,
        s3: 2210,
        s4: 5280,
    },
    {
        name: '2016',
        s1: 2000,
        s2: 9800,
        s3: 2290,
        s4: 2016,
    },
    {
        name: '2017',
        s1: 2780,
        s2: 3908,
        s3: 2000,
        s4: 1500,
    },
    {
        name: '2018',
        s1: 1890,
        s2: 4800,
        s3: 2181,
        s4: 3181,
    },
    {
        name: '2019',
        s1: 2390,
        s2: 3800,
        s3: 2500,
        s4: 2000,
    },
    {
        name: '2020',
        s1: 3490,
        s2: 4300,
        s3: 2100,
        s4: 1281,
    },
];

export const mainTrends = {
    stageI_II: {
        data: [64.57,  66.86,  69.11,  69.63,  71.25,  72.79,  74.16,  74.97,  76.25,  78.03,  77.32],
        ltr: 0.21
    },
    live5y: {
        data: [47.66,  48.89,  48.90,  49.42,  49.97,  50.27,  51.92,  52.53,  52.74,  54.66,  55.84],
        ltr: 0.76
    },
    live1y: {
        data: [21.31,  19.47,  18.93,  17.93,  17.47,  16.53,  16.55,  14.91,  14.45,  14.27,  14.01],
        ltr: -0.71
    },
    dnl: {
        data: [49,        50,     51,     52,    53,      54,     55, 56,      57,   58,    59],
        ltr: 1

    }
}

const Model = {
    stepOption, stepConnection, mainTrends, data, modeling,
    defaultStrategy: {
        H1A: '0', H2A: '0', H3A: '0',
        H1B: '10', H2B: '20', H3B: '40',
        M1: '25',
        M2: '30'
    },
    name: "Рак мочевого пузыря",
    options: {
        showTrends: true,
        mainView: {
            title: "Выявление по стадиям",
            lines: [
                {key: "s1", title: "I стадия"},
                {key: "s2", title: "II стадия"},
                {key: "s3", title: "III стадия"},
                {key: "s4", title: "IV стадия"},
            ]
        }
    },
    vars: {
        strategy: [
            {title: "Доля направленных на Атезолизумаб после прогрессирование на Цисплатине, %", prefix: "H1"},
            {title: "Доля направленных на Атезолизумаб PD-L1+, %", prefix: "H2"},
            {title: "Доля направленных на Атезолизумаб PD-L1-, %", prefix: "H3"},
        ],
        mutation: [
            {title: "Прогрессирование после II стадии, %", prefix: "M1"},
            {title: "Прогрессирование после III стадии, %", prefix: "M2"},
        ]
    },
}

export default Model */